const DollarIcon = ({ size = 24, ...props }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.5 6.5C14.8 5.2 13.2 4.3 11.5 4.3C9.2 4.3 7.3 5.6 7.3 7.5C7.3 9.4 9.2 10 11.5 10.6C13.8 11.2 15.7 11.9 15.7 13.8C15.7 15.7 13.8 17 11.5 17C9.5 17 7.7 16.1 7 14.6"
                stroke="#0069AD"
                strokeWidth="1.125"
                strokeLinecap="round"
            />
            <path
                d="M11.5 2.5V19.5"
                stroke="#00A7E4"
                strokeWidth="1.125"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default DollarIcon;